import React from "react";
import { FaUserFriends, FaPencilAlt, FaBan, FaCheck, FaClipboardList } from "react-icons/fa";

export default function TablaMiembros({
  miembros,
  loading,
  onEditar,
  onEncuesta,
  onCambiarEstado,
  encuestaActiva,
  respondidos = [],
}) {
  return (
    <div className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden">
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-slate-50 text-xs uppercase text-slate-500">
            <tr>
              <th className="px-4 py-3 text-left font-semibold">ID</th>
              <th className="px-4 py-3 text-left font-semibold">Nombre completo</th>
              <th className="px-4 py-3 text-left font-semibold">Dirección</th>
              <th className="px-4 py-3 text-left font-semibold">Teléfonos</th>
              <th className="px-4 py-3 text-left font-semibold">Correo</th>
              <th className="px-4 py-3 text-left font-semibold">Estatus</th>
              <th className="px-4 py-3 text-right font-semibold">Acciones</th>
            </tr>
          </thead>

          <tbody>
            {loading ? (
              <tr>
                <td colSpan={7} className="text-center py-10 text-slate-400">
                  Cargando...
                </td>
              </tr>
            ) : miembros.length === 0 ? (
              <tr>
                <td colSpan={7} className="text-center py-10 text-slate-400">
                  No hay miembros registrados
                </td>
              </tr>
            ) : (
              miembros.map((m) => {
                const activo = m.status !== false;
                const yaRespondio = respondidos.includes(m.id_miembro);
                return (
                  <tr
                    key={m.id_miembro}
                    className="border-t border-slate-100 hover:bg-slate-50 transition"
                  >
                    <td className="px-4 py-3 text-slate-500 tabular-nums">{m.id_miembro}</td>
                    <td className="px-4 py-3">
                      <span className="flex items-center gap-2 font-medium text-slate-800">
                        <span className="w-7 h-7 rounded-md bg-indigo-50 text-indigo-600 flex items-center justify-center shrink-0">
                          <FaUserFriends className="text-xs" />
                        </span>
                        {m.nombre} {m.paterno} {m.materno}
                      </span>
                    </td>
                    <td className="px-4 py-3 text-slate-600">{m.direccion || "—"}</td>
                    <td className="px-4 py-3 text-slate-600">{m.telefonos || "—"}</td>
                    <td className="px-4 py-3 text-slate-600">{m.email || "—"}</td>
                    <td className="px-4 py-3">
                      <span className="flex items-center gap-2 text-slate-600">
                        <span className={`w-2 h-2 rounded-full ${activo ? "bg-emerald-500" : "bg-slate-300"}`} />
                        {activo ? "Activo" : "Inactivo"}
                      </span>
                    </td>
                    <td className="px-4 py-3">
                      <div className="flex items-center justify-end gap-2">
                        <button
                          onClick={() => onEditar(m)}
                          title="Editar"
                          className="w-8 h-8 flex items-center justify-center rounded-md border border-slate-200 text-slate-500 hover:bg-indigo-50 hover:text-indigo-700 hover:border-indigo-200 transition"
                        >
                          <FaPencilAlt className="text-xs" />
                        </button>

                        {encuestaActiva && onEncuesta && (
                          <button
                            onClick={() => onEncuesta(m)}
                            title={yaRespondio ? "Censo respondido" : "Realizar censo"}
                            className={`w-8 h-8 flex items-center justify-center rounded-md border transition ${
                              yaRespondio
                                ? "border-emerald-200 text-emerald-600 hover:bg-emerald-50"
                                : "border-slate-200 text-slate-500 hover:bg-indigo-50 hover:text-indigo-700 hover:border-indigo-200"
                            }`}
                          >
                            <FaClipboardList className="text-xs" />
                          </button>
                        )}

                        {activo ? (
                          <button
                            onClick={() => onCambiarEstado(m)}
                            title="Desactivar"
                            className="w-8 h-8 flex items-center justify-center rounded-md border border-slate-200 text-slate-500 hover:bg-rose-50 hover:text-rose-600 hover:border-rose-200 transition"
                          >
                            <FaBan className="text-xs" />
                          </button>
                        ) : (
                          <button
                            onClick={() => onCambiarEstado(m)}
                            title="Reactivar"
                            className="w-8 h-8 flex items-center justify-center rounded-md border border-slate-200 text-slate-500 hover:bg-emerald-50 hover:text-emerald-600 hover:border-emerald-200 transition"
                          >
                            <FaCheck className="text-xs" />
                          </button>
                        )}
                      </div>
                    </td>
                  </tr>
                );
              })
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
